import React, { useState } from "react";
import { Row, Col, Button } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  FilterOutlined,
  DownOutlined,
} from "@ant-design/icons";

import "./styles.css";

const Logo = (props) => {
  const {
    collapsed,
    setCollapsed,
    isMobile,
    isTablet,
    onMobileMenuToggle,
    showLogo = true,
    showHamburger = true,
    showFilterButton = false,
    isFullWidthFilter = false, // New prop for mobile full-width filter
    openFilterModal,
    filterProps = {},
  } = props;

  const {
  currentCouncil,
  } = filterProps;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleMenuClick = () => {
    if (isMobile) {
      onMobileMenuToggle();
    } else {
      setCollapsed(!collapsed);
    }
  };

  // Inline filter sheet handlers removed; using AntD Modal for filters

  // Mobile Row 1: Logo and Hamburger only
  if (isMobile && showLogo && showHamburger && !showFilterButton) {
    return (
      <div className="mobile-row-1">
        <div className="mobile-title">PRST</div>
        <div className="mobile-hamburger" onClick={handleMenuClick}>
          {/* Use MenuUnfoldOutlined for hamburger everywhere */}
          <MenuUnfoldOutlined className="hamburger-icon" />
        </div>
      </div>
    );
  }

  // Mobile Row 2: Full width filter button only
  if (
    isMobile &&
    !showLogo &&
    !showHamburger &&
    showFilterButton &&
    isFullWidthFilter
  ) {
    return (
      <>
        <div className="mobile-row-2">
          <Button
            className="mobile-filter-button-fullwidth"
            onClick={openFilterModal}
            icon={<FilterOutlined />}
          >
            <span className="filter-button-text">
              {currentCouncil ? currentCouncil : "Select Municipal"}
            </span>
            <DownOutlined className="filter-dropdown-icon" />
          </Button>
        </div>
      </>
    );
  }

  // Tablet: Centered filter button only
  if (isTablet && !showLogo && !showHamburger && showFilterButton) {
    // Tablet sidebar width: collapsed = 60px, expanded = 250px (default collapsed)
    const tabletSiderWidth = 60;
    return (
      <>
        <div className="tablet-filter-only">
          <Button
            className="mobile-filter-button-fullwidth"
            onClick={() => {
              setCollapsed(true);
              openFilterModal();
            }}
            icon={<FilterOutlined />}
          >
            <span className="filter-button-text">
              {currentCouncil ? currentCouncil : "Select Municipal"}
            </span>
            <DownOutlined className="filter-dropdown-icon" />
          </Button>
        </div>
      </>
    );
  }

  // Desktop collapsed view
  if (collapsed) {
    return (
  <div className="logo-collapsed-container">
        <div className="logo-menu" onClick={handleMenuClick}>
          <MenuUnfoldOutlined className="logo-menu__icon" />
        </div>
      </div>
    );
  }

  // Desktop expanded view
  return (
    <Row align="middle" className="logo-row">
      <Col
        span={6}
        className="logo-col-left"
      >
        <div className="logo-menu" onClick={handleMenuClick}>
          <MenuFoldOutlined className="logo-menu__icon" />
        </div>
      </Col>
      {showLogo && (
        <Col span={17} className="logo-col-title">
          <div className="logo__title">PRST</div>
        </Col>
      )}
    </Row>
  );
};

export default Logo;
